<template>
  <div class="destination_">
    <div class="row justify-content-end __centerblock">
      <div class="col-md-5 p-0 __block1">
          <h3 class="__title2">Origin</h3>
          <div class="__customdropdown_dst2">
            <b-input-group>
              <b-dropdown>
                <template slot="button-content">
                  {{ origin }}
                </template>
                <b-dropdown-item @click="chkArea('Port','ori'), PickupAddressOri=false"><span>Port</span></b-dropdown-item>
                <b-dropdown-item @click="chkArea('Door','ori'), PickupAddressOri=true"><span>Door</span></b-dropdown-item>
              </b-dropdown>
              <img class="__imgArrow" src = "@/assets/image/instantprice/right-arrow.svg">
            </b-input-group>
          </div>
          <div class="pb-4">
            <v-select
              v-model="originCountry"
              :options="countryList"
              label="name"
              placeholder="Origin Country"
              @input="chkInputLocation('originCountry')"
            />
            <div v-if="showErrorDestination && error.originCountry" class="text-left input-group __input">
              <small class="text-danger">Required</small>
            </div>
          </div>

          <v-select
            v-model="originCity"
            :options="cityList"
            label="name"
            placeholder="Origin City"
            @input="chkInputLocation('originCity')"
          />
          <div v-if="showErrorDestination && error.originCity" class="text-left input-group __input">
              <small class="text-danger">Required</small>
            </div>
          <div class="mt-4" v-if="PickupAddressOri">
              <b-form-textarea
                id="textarea"
                placeholder="Type Your Pick Up Address"
                rows="3"
                max-rows="5"
                class="__textarea"
                v-model="form.pickup_address"
              />
              <div v-if="showErrorDestination && error.pickUpAddress" class="text-left input-group __input">
                <small class="text-danger">Required</small>
              </div>
          </div>
      </div>
      <div class="col-md-2 p-0">
        <div class="text-center __block2">
        </div>
      </div>
      <div class="col-md-5 p-0 __block3">
        <h3 class="__title2">Destination</h3>
        <div class="__customdropdown_dst2">
          <b-input-group>
            <b-dropdown>
              <template slot="button-content">
                {{ destination }}
              </template>
              <b-dropdown-item @click="chkArea('Port','des'),PickupAddressDest=false"><span>Port</span></b-dropdown-item>
              <b-dropdown-item @click="chkArea('Door','des'), PickupAddressDest=true"><span>Door</span></b-dropdown-item>
            </b-dropdown>
            <img class="__imgArrow" src = "@/assets/image/instantprice/right-arrow.svg">
          </b-input-group>
        </div>

        <div class="pb-4">
          <v-select
            v-model="destinationCountry"
            :options="countryList"
            label="name"
            placeholder="Destination Country"
            @input="chkInputLocation('destinationCountry')"
          />
          <div v-if="showErrorDestination && error.destinationCountry" class="text-left input-group __input">
            <small class="text-danger">Required</small>
          </div>
        </div>

        <v-select
          v-model="destinationCity"
          :options="destinationCityList"
          label="name"
          placeholder="Destination City"
          @input="chkInputLocation('destinationCity')"
        />
        <div v-if="showErrorDestination && error.destinationCity" class="text-left input-group __input">
          <small class="text-danger">Required</small>
        </div>
        <div class="mt-4" v-if="PickupAddressDest">
            <b-form-textarea
              id="textarea"
              placeholder="Type Your Delivery Up Address"
              rows="3"
              max-rows="5"
              class="__textarea"
              v-model="form.delivery_address"
            />
            <div v-if="showErrorDestination && error.deliveryAddress" class="text-left input-group __input">
              <small class="text-danger">Required</small>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'

export default {
  name: 'destination',
  props: {
    showErrorDestination: Boolean,
    inputData: Object
  },
  components: {
    vSelect
  },
  data () {
    return {
      origin: 'Port',
      destination: 'Port',
      originCountry: '',
      destinationCountry: '',
      originCity: '',
      destinationCity: '',
      PickupAddressOri: false,
      PickupAddressDest: false,
      form: {
        originArea: 'Port',
        destinationArea: 'Port',
        typeObj: 'sub',
        originCountry: '',
        originCity: '',
        destinationCountry: '',
        destinationCity: '',
        pickup_address: '',
        delivery_address: '',
        optiontp: 'ptp'
      },
      error: {}
    }
  },
  computed: {
    ...mapGetters({
      cityList: 'city/city',
      countryList: 'city/country',
      isCityLoading: 'city/isLoading',
      //
      destinationCityList: 'city/destinationCities',
      isCityDestinationLoading: 'city/isLoadingDestination'
    }),
    pickup_address () {
      return this.form.pickup_address
    },
    delivery_address () {
      return this.form.delivery_address
    },
    oCountry () {
      return this.form.originCountry
    },
    dCountry () {
      return this.form.destinationCountry
    },
    oCity () {
      return this.form.originCity
    },
    dCity () {
      return this.form.destinationCity
    }
  },
  mounted () {
    this.$store.dispatch('city/FETCH_COUNTRIES')
    this.chkOptiontp(this.form.originArea, this.form.destinationArea)
    this.init()
  },
  methods: {
    init () {
      const data = this.form
      let error = this.error
      /* eslint-disable */
      error.originCountry = (data.originCountry === '') ? true : false
      error.originCity = (data.originCity === '') ? true : false
      error.destinationCountry = (data.destinationCountry === '') ? true : false
      error.destinationCity = (data.destinationCity === '') ? true : false
      error.pickUpAddress = data.pickup_address === '' ? true : false
      error.deliveryAddress = data.delivery_address === '' ? true : false
      if (this.inputData.shipmentLoad === 'aircourier') {
        this.origin = 'Door'
        data.originArea = 'Door'
        this.PickupAddressOri = true
        this.destination = 'Door'
        data.destinationArea = 'Door'
        this.PickupAddressDest = true
        this.form.optiontp = 'dtd'
      }
      this.$emit('IntantPriceData', this.form)
    },
    chkInputLocation (type) {
      // checking type
      const form = this.form
      if (type === 'originCountry') {
        this.form.originCountry = this.originCountry ? this.originCountry.code : ''
        this.form.originCity = ''
        this.originCity = ''
      } else if (type === 'destinationCountry') {
        this.form.destinationCountry = this.destinationCountry ? this.destinationCountry.code : ''
        this.form.destinationCity = ''
        this.destinationCity=''
      } else if (type === 'originCity') {
        this.form.originCity =  this.originCity ? this.originCity.code : ''
      } else {
        // type => destinationCity
        this.form.destinationCity = this.destinationCity ? this.destinationCity.code : ''
      }

      // checking destination is exist
      if (form.originCountry && form.destinationCountry) {
        this.$emit('IntantPriceDestination', `${this.originCountry.name} - ${this.destinationCountry.name}`)
      }
      this.$emit('IntantPriceData', this.form)
    },

    chkArea (value, type) {
      if (type === 'ori') {
        this.origin = value
        this.form.originArea = value
      } else {
        this.destination = value
        this.form.destinationArea = value
      }
      this.chkOptiontp(this.form.originArea, this.form.destinationArea)
    },
    chkOptiontp (from, to) {
      if (from === 'Port' && to === 'Port') {
        this.form.optiontp = 'ptp'
      } else if (from === 'Port' && to === 'Door') {
        this.form.optiontp = 'ptd'
      } else if (from === 'Door' && to === 'Port') {
        this.form.optiontp = 'dtp'
      } else if (from === 'Door' && to === 'Door') {
        this.form.optiontp = 'dtd'
      }
      this.$emit('IntantPriceData', this.form)
    }
  },
  watch: {
    originCountry (data) {
      /* eslint-disable-next-line */
      this.error.originCountry = data ? false : true
      if (data) {
        this.$store.dispatch('city/FETCH_CITIES', data.code)
      } 
       this.$emit('IntantPriceData', this.form)
    },
    destinationCountry (data) {
      /* eslint-disable-next-line */
      this.error.destinationCountry = data ? false : true
      if (data) {
        this.$store.dispatch('city/FETCH_CITIES_DESTINATION', data.code)
      } 
      this.$emit('IntantPriceData', this.form)
    },
    originCity (data) {
      /* eslint-disable-next-line */
      this.error.originCity = data ? false : true
      this.form.originCity = data && data.code ? data.code : ''
      this.$emit('IntantPriceData', this.form)
    },
    destinationCity (data) {
      /* eslint-disable-next-line */
      this.error.destinationCity = data ? false : true
      this.form.destinationCity = data && data.code ? data.code : ''
      this.$emit('IntantPriceData', this.form)
    },
    pickup_address (data) {
      this.error.pickUpAddress = data ? false : true
      this.$emit('IntantPriceData', this.form)
    },
    delivery_address (data) {
      this.error.deliveryAddress = data ? false : true
      this.$emit('IntantPriceData', this.form)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/instantPrice/Destination.vue